module.exports = __webpack_public_path__ + "img/MMI_LOGO.c4382372.png";